import $http from "@/utils/http"

// 文件上传
export default  function(data,type=null,size=null,time=null) {
    // 接收四个参数：data上传文件信息 type文件格式要求 size文件最大限制 timeout请求超时时间
    return new  Promise((resolve,reject)=>{
        if(size){
            // 检验文件大小是否超出
            let isLtM = data.file.size / 1024 / 1024 < size // 大小超过直接ruturn掉
            if (!isLtM){
                resolve({ message:'文件大小超出了!'})
                return
            }
        }
        var isMatch=null
        if(type){
            // 检验格式是否匹配
            isMatch=type.some((item)=>{
                return data.file.name.endsWith(item)
            })
        }else{
            isMatch=true
        }
        if(isMatch){
            // 格式匹配
            var formData = new FormData()  
            formData.append('file',data.file)  
            $http
            .post("v1/elecbook/elecbookfile",formData,{timeout:time})
            .then((res) => {  // 发送http请求
                console.log('======res',res)
                if(res && res.status == 200){  
                    let file = {  
                        uid: data.file.uid,    // 文件唯一标识  
                        astModified:data.file.astModified,//属性值astModified
                        name: data.file.name,   // 文件名  
                        size:data.file.size, //文件大小
                        type:data.file.type, //文件类型
                        status: 'done', // 上传状态：uploading done error  
                        code: 200, //自定义code
                        partPath:res.data.partPath, //返回相对路劲
                        fullReadPath:res.data.fullReadPath, //返回绝对路劲
                    }  
                    resolve(file)
                }else {  
                    resolve({ message:'上传失败，请重试!'})  
                }  
            })
            .catch((err)=>{
                reject(err)
            })
           
        }else{
            // 格式不正确时 列表不显示
            resolve({ message:'请上传格式正确的文件!'})
        }
    })
}
